import { createReducer, on, Action } from '@ngrx/store';
import * as suppliersActions from '../actions/suppliers.actions';
import { SuppliersResponseModel } from 'app/models/suppliers.model';

export interface State {
  suppliers: SuppliersResponseModel;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  suppliers: { results: [], count: 0 },
  isLoading: false,
  isReady: false,
  isSaving: false,
};

export const featureReducer = createReducer(
  initialState,
  on(suppliersActions.loadSuppliers, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(suppliersActions.loadSuppliersSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    suppliers: response,
  })),
  on(
    suppliersActions.createSupplier,
    suppliersActions.updateSupplier,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    suppliersActions.createSupplierSuccess,
    suppliersActions.createSupplierFailure,
    suppliersActions.updateSupplierSuccess,
    suppliersActions.updateSupplierFailure,
    (state) => ({
      ...state,
      isSaving: false,
    })
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
